<div class="field" #fieldGroups>
    <span class="field-title">Lugar de entrega<span class="asterisk">*</span></span>

    <app-zone style="margin-top: -8px;" [fieldIdentificator]="fieldIdentificator" (focusEvent)="emitField(fieldGroups)"></app-zone>
    <app-port style="margin-top: -8px;" [fieldIdentificator]="fieldIdentificator" [requirePort]="requirePort"
    [incompleteRequirePort]="incompleteRequirePort"
    [ngClass]="{'invisible': zoneNotHavePort()}" (tab)="emit($event)" (focusEvent)="emitField(fieldGroups)"></app-port>
</div>